const complaintRegister = {
  data: [],
  status: 'idle',
  error: ''
};

const complaintRegisterReducer = (state = complaintRegister, action) => {
  switch (action.type) {
    case 'GET_COMPLAINT_REGISTER_REQUEST':
      return {
        ...state,
        status: 'pending'
      };
    case 'GET_COMPLAINT_REGISTER_FAILURE':
      return {
        ...state,
        status: 'rejected',
        error: action.payload
      };
    case 'GET_COMPLAINT_REGISTER_SUCCESS':
      return {
        ...state,
        status: 'resolve',
        data: action.payload.data.data
      };
    default:
      return state;
  }
};

export { complaintRegisterReducer };
